import { MasterMedicine } from '../../apis/master-medicines/types';
import { MasterMedicineSelectorOption } from './interface';
import { useMasterMedicines } from './useMasterMedicines';
import { createOptions, getSelectedOption } from './utils';

interface UseMasterMedicineOptionsProps {
  searchedMasterMedicines: MasterMedicine[];
  selectedMasterMedicinesId: string;
}

interface UseMasterMedicineOptionsReturn {
  options: MasterMedicineSelectorOption[];
  selectedOptions?: MasterMedicineSelectorOption[];
}

function useMasterMedicineOptions({
  searchedMasterMedicines,
  selectedMasterMedicinesId
}: UseMasterMedicineOptionsProps): UseMasterMedicineOptionsReturn {
  const { masterMedicines } = useMasterMedicines();
  const selectedOptions = getSelectedOption(selectedMasterMedicinesId, masterMedicines);

  return {
    options: createOptions(searchedMasterMedicines),
    selectedOptions
  };
}

export default useMasterMedicineOptions;
